"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isOneDay(startDate, endDate) {
    var start = new Date(startDate || 0);
    start.setHours(0, 0, 0, 1);
    var end = new Date(endDate || 0);
    end.setHours(0, 0, 0, 1);
    return start.valueOf() === end.valueOf();
}
exports.isOneDay = isOneDay;
//# sourceMappingURL=helpers.js.map